import { _ } from "libs";
import React from "react";
import { MessagePartnerHash } from "../../types";
import { filterUnique } from "../../actions/helpers";
import withRedux from "../../withRedux";
import { RootState } from "../../reducers";

const Indicator = ({ children = null }) => {
	return <div className="typingIndicator">{children}</div>;
};

function TypingIndicator({
	partners,
	typingPartners,
	myId,
}: {
	partners: MessagePartnerHash;
	typingPartners: string[];
	myId: string;
}) {
	const names = filterUnique(typingPartners).map((uuid: string) => {
		if (uuid === myId) {
			return <Indicator />;
		}

		if (!partners[uuid]) {
			return <Indicator />;
		}

		return partners[uuid].firstName;
	});

	if (names.length === 0) {
		return <Indicator />;
	}

	const partnersNames = names.slice(0, names.length - 1).join(", ");
	const lastPartnersName = names[names.length - 1];

	return (
		<Indicator>
			{_("chat.typingIndicator.typing.text", names.length, {
				partnerNames: partnersNames,
				lastPartnersName: lastPartnersName,
			})}
		</Indicator>
	);
}

const mapStateToProps = ({ typing: { typingPartners } }: RootState) => {
	return { typingPartners };
};

export default withRedux({}, mapStateToProps)(TypingIndicator);
